import { classifyPortfolioResponse } from "./portfolioData.js";

export const WORLD_ENDPOINTS = Object.freeze({
  pulse: [
    ["critical-summary", "Critical Summary", "/api/frontend-critical-summary", "Der verdichtete Frontend-Systemzustand."],
    ["readiness", "Readiness", "/api/frontend-critical-summary/readiness", "Schneller Bereitschafts- und Verbindungscheck."],
    ["operator-summary", "Operator Summary", "/api/admin/operator-summary", "Top-Probleme, Lage und nächste Schritte."],
    ["guardian", "Guardian", "/api/admin/guardian-status-summary", "Risiko-, Stabilitäts- und Schutzstatus."],
    ["world-state", "World State", "/api/admin/world-state", "Kanonischer Markt- und Systemkontext."],
    ["operational-status", "Operational Status", "/api/admin/operational-status", "Laufender Betriebszustand."],
    ["alerts-summary", "Alerts", "/api/admin/alerts/summary", "Aktive kritische, warnende und informative Meldungen."],
  ],
  intelligence: [
    ["forecast-outcome", "Forecast vs. Outcome", "/api/admin/forecast-vs-outcome", "Prognosen gegen realisierte Ergebnisse."],
    ["signal-kpis", "Signal KPIs", "/api/admin/signal-kpis", "Kanonische Signalmetriken."],
    ["signal-history", "Signal History", "/api/admin/signal-history", "Historie der erzeugten Signale."],
    ["outcome-analysis", "Outcome Analysis", "/api/admin/outcome-analysis", "Auswertung realisierter Ergebnisse."],
    ["timing-quality", "Timing Quality", "/api/admin/timing-quality", "Qualität der Ein- und Ausstiegszeitpunkte."],
    ["factor-returns", "Factor Forward Returns", "/api/admin/factor-forward-returns", "Persistierte Faktor-Forward-Returns."],
    ["discovery-results", "Discovery Results", "/api/admin/discovery-results", "Realisierte Discovery-Ergebnisse."],
    ["forecast-quality", "Forecast Quality", "/api/admin/forecast-quality", "Forecast-Bestand und Qualitätsstatus."],
  ],
  capital: [
    ["saved-capital", "Saved Capital", "/api/admin/saved-capital", "Durch Schutzentscheidungen erhaltenes Kapital."],
    ["near-misses", "Near Misses", "/api/admin/near-misses", "Verhinderte oder beinahe eingetretene Verluste."],
    ["guardian", "Guardian Summary", "/api/admin/guardian-status-summary", "Aktuelle Schutz- und Risikolage."],
    ["portfolio-twin", "Portfolio Twin", "/api/admin/portfolio-twin", "Digitaler Kapital- und Positionszwilling."],
    ["virtual-positions", "Virtual Positions", "/api/admin/virtual-positions", "Paper- und Simulationspositionen."],
    ["interface-state", "Interface State", "/api/admin/interface-state", "Sicherheits- und Ausführungszustand der Oberfläche."],
  ],
  portfolio: [
    ["demo-portfolio", "Demo Portfolio", "/api/admin/demo-portfolio", "Gesamtbestand des Demoportfolios."],
    ["portfolio-twin", "Portfolio Twin", "/api/admin/portfolio-twin", "Portfolio-Snapshot und Twin-Vertrag."],
    ["virtual-positions", "Virtual Positions", "/api/admin/virtual-positions", "Aktive virtuelle Positionen."],
    ["proof-summary", "Portfolio Proof", "/api/admin/demo-portfolio/proof/summary", "Beweisstatus aktiver, geplanter und verkaufter Positionen."],
    ["manager-overview", "Manager Agent", "/api/admin/demo-portfolio/manager-agent/overview", "Entscheidungen des Portfolio-Manager-Agenten."],
    ["paper-execution", "Paper Execution", "/api/admin/demo-portfolio/paper-execution/overview", "Sichere Paper-Ausführungsübersicht."],
    ["daily-runner", "Daily Runner", "/api/admin/demo-portfolio/daily-runner/overview", "Tageslauf, Safety und letzter Status."],
  ],
  agents: [
    ["agent-status", "Agent Status", "/api/admin/agent-status", "Konfiguration und Erreichbarkeit aller Agenten."],
    ["conference-health", "Conference Health", "/api/admin/agent-conference/health", "Gesundheit der Multi-Agent-Konferenz."],
    ["conference-sessions", "Conference Sessions", "/api/admin/agent-conference/sessions", "Aktuelle und vergangene Konferenzen."],
    ["work-sessions", "Agent Work", "/api/admin/agent-work/sessions", "Aktive, blockierte und abgeschlossene Agentenarbeit."],
    ["proposal-readiness", "Proposal Readiness", "/api/admin/conference/proposal-readiness", "Freigabereife erzeugter Vorschläge."],
    ["control-cases", "Control Center Cases", "/api/admin/conference/control-center-cases", "Fälle, Blocker und Eskalationen."],
    ["operator-approvals", "Approvals", "/api/admin/agents/operator/approvals", "Ausstehende menschliche Freigaben."],
  ],
  operations: [
    ["pipeline", "Pipeline Status", "/api/admin/pipeline-status", "Schritte, Laufzeiten und Blocker."],
    ["table-health", "Table Health", "/api/admin/table-health", "Datenbanktabellen, Zeilen und Aktualität."],
    ["service-diagnostics", "Service Diagnostics", "/api/admin/service-diagnostics", "Gesundheit einzelner Dienste."],
    ["data-flow", "Data Flow Health", "/api/admin/data-flow-health", "Durchgängigkeit des Datenpfads."],
    ["db-capacity", "DB Capacity", "/api/admin/db-capacity", "Kapazität und Belastung der Datenbank."],
    ["freshness", "Data Freshness", "/api/admin/data-freshness", "Veraltete oder unbekannte Datenbereiche."],
    ["prices-coverage", "Price Coverage", "/api/admin/prices-daily/coverage", "Abdeckung der täglichen Preisdaten."],
  ],
  learning: [
    ["weights", "Agent Weights", "/api/admin/agent-weights", "Persistierte Agentengewichte."],
    ["dynamic-weights", "Dynamic Weights", "/api/admin/dynamic-weights", "Dynamische Gewichtung nach Ergebnisqualität."],
    ["diagnostics", "Learning Diagnostics", "/api/admin/learning-diagnostics", "Reife, Datenbasis und Blocker des Lernens."],
    ["forecast-quality", "Forecast Quality", "/api/admin/forecast-quality", "Forecast-Bestand als Lernbasis."],
    ["runtime-current", "Runtime State", "/api/admin/runtime/current", "Aktueller versionierter Lernzustand."],
  ],
  proof: [
    ["quality-audit", "Quality Audit", "/api/admin/quality-audit", "Readiness, Confidence, Coverage und Reife."],
    ["core-readiness", "Core Readiness", "/api/admin/core-readiness?details=true&window=30d&limit=50", "Gesamtreife der HQS-Kernfunktionen."],
    ["performance-proof", "Performance Proof", "/api/admin/performance-proof?window=30d&limit=50", "Verifizierte Outcomes und Performancebelege."],
    ["signal-history", "Signal Lineage", "/api/admin/signal-history", "Beweiskette der Signale."],
    ["runtime-snapshots", "Runtime Snapshots", "/api/admin/runtime/snapshots", "Versionierte Zustände und Rollback-Beweise."],
    ["portfolio-proof", "Portfolio Proof", "/api/admin/demo-portfolio/proof/summary", "Beweiszusammenfassung des Demoportfolios."],
  ],
  expert: [],
});

export function getWorldEndpoints(world) {
  return (WORLD_ENDPOINTS[world] || WORLD_ENDPOINTS.pulse).map(([id, label, path, description]) => ({ id, label, path, description }));
}

// Every possible return value of classifyEndpointResult(). A 401/403/504
// must never be classified as "live", and a null/empty payload is always
// its own distinct "empty" state — never folded into "live" as if it were
// successfully retrieved content (see summarizeEndpointResults() /
// LiveWorldPanel's coverage calculation, which only counts "live").
export const ENDPOINT_STATES = Object.freeze([
  "checking", "live", "partial", "empty", "unavailable", "rate_limited", "auth_expired", "auth_forbidden", "degraded", "timeout", "error",
]);

export function classifyEndpointResult(result) {
  if (!result || typeof result !== "object") return "error";
  if (result.status === 429) return "rate_limited";
  if (result.meta?.notFound || result.meta?.notImplemented || result.status === 404 || result.status === 501) return "unavailable";
  const classification = classifyPortfolioResponse(result);
  switch (classification.status) {
    case "checking":
      return "checking";
    case "live":
      return "live";
    case "partial":
      return "partial";
    case "empty":
      return "empty";
    case "rate_limited":
      return "rate_limited";
    case "unauthorized":
      return result.status === 403 ? "auth_forbidden" : "auth_expired";
    case "timeout":
      return "timeout";
    case "unavailable":
      return "unavailable";
    default:
      return "error";
  }
}

export function summarizeEndpointResults(results) {
  const summary = { total: results.length };
  for (const state of ENDPOINT_STATES) summary[state] = 0;
  for (const result of results) {
    const state = result.state || classifyEndpointResult(result);
    if (state in summary) summary[state] += 1;
  }
  return summary;
}

export function unwrapBackendPayload(result) {
  if (!result || typeof result !== "object") return null;
  return result.data?.data ?? result.data ?? null;
}
